export default "__VITE_ASSET__b252cbed__"